/*
 * Copyright (c) 2008-2025 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */
/* eslint-env node */

import Vue from "vue"
import Vuex from "vuex"
import admin from "./admin"
import auth from "./auth"
import cms from "./cms"
import effectiveLicenses from "./effectiveLicenses"
import licensing from "./licensing"
import lanEvent from "./lanEvent"
import meetings from "./meetings"
import contributions from "./contributions"
import rql from "./rql"
import serverStatistics from "./serverStatistics"
import settings from "./settings"
import tenants from "./tenants"
import user from "./user"
import users from "./users"
import participants from "./participants"
import publications from "./publications"
import statusMessages from "./statusMessages"
import inheritableConfig from "./inheritableConfig"

Vue.use(Vuex)

export default new Vuex.Store({
  // todo DIY: this setting produces lots of errors, e.g. when dragging things around :-( - how to do things right??
  strict: process.env.NODE_ENV !== "production",
  modules: {
    auth,
    cms,
    effectiveLicenses,
    licensing,
    meetings,
    contributions,
    rql,
    admin,
    lanEvent,
    settings,
    tenants,
    user,
    users,
    participants,
    publications,
    statusMessages,
    serverStatistics,
    inheritableConfig,
  },
})
